import { useIntl } from 'react-intl';

import { useBasicInfo } from '@/src/listings/components/_shared/contexts/BasicInfoContext';
import { MULTIPLE_DATES } from '@/src/listings/components/_shared/constants';
import { useAttendeeTimezone } from '@/src/listings/hooks/useAttendeeTimezone';
import { getDisplayTimezone, getSingleDateDisplayString } from '@/src/listings/utils/dateTime';

import styles from './ExternalTicketsPanel.module.scss';

export const ExternalTicketsPanelDate: React.FC = () => {
  const { formatMessage, locale } = useIntl();
  const { endDate, hideEndDate, startDate, hideStartDate, isSeries, isOnline } = useBasicInfo();
  const attendeeTimezone = useAttendeeTimezone(isOnline ?? false);

  const showEndTimeOnly = hideStartDate && !hideEndDate && endDate?.utc;

  const timezone = getDisplayTimezone({
    isOnlineEvent: isOnline ?? false,
    eventTimezone: startDate?.timezone,
    attendeeTimezone,
  });

  const dateString = isSeries
    ? formatMessage(MULTIPLE_DATES)
    : startDate
      ? getSingleDateDisplayString(
          startDate,
          !hideStartDate,
          locale,
          timezone,
          formatMessage,
          false,
          !showEndTimeOnly ? ' • ' : undefined,
          true,
          isOnline ?? false,
        )
      : undefined;

  if (!dateString) {
    return null;
  }

  return (
    <div data-testid="conversion-bar-date" className={styles.date}>
      {dateString}
    </div>
  );
};
